module.exports = __webpack_public_path__ + "static/media/bot_order_none_white.d1adf596.png";